const PreferenceCenter_areAllOptionsDisabled = require("./PreferenceCenter_areAllOptionsDisabled");
const PreferenceCenter_disablePrivacyPolicy = require("./PreferenceCenter_disablePrivacyPolicy");
const PreferenceCenter_enablePrivacyPolicy = require("./PreferenceCenter_enablePrivacyPolicy");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function PreferenceCenter_refreshPrivacyPolicy(preferenceCenter) {
    const areAllOptionsDisabled = PreferenceCenter_areAllOptionsDisabled(preferenceCenter);

    if (areAllOptionsDisabled) {
        PreferenceCenter_disablePrivacyPolicy(preferenceCenter);
    } else {
        PreferenceCenter_enablePrivacyPolicy(preferenceCenter);
    }
}